import {Stats} from './stats';

export class Equipment {
	type:string;
	stats:Stats=new Stats();;
	level:number=0;
	set:string;
	enhancementLvl:number=0;
	mainStat:string;
	rarity:string;
}